import OSS from "ali-oss";
import { _getAliYunSts } from "@/api/upload";
import util from "@/base/js/util";
//ali-oss文档    https://help.aliyun.com/document_detail/64047.html?spm=a2c4g.11186623.6.1274.19027214K0VMuf

const noop = () => { }

export default class {
  constructor({ onProgress, onSuccess, onError }) {
    this.options = {
      secure: true,
      cname: true,
      endpoint: 'oss.zhidx.com',
      region: 'oss-cn-beijing', //bucket 所在的区域
      accessKeyId: '<Your AccessKeyId>',  //通过阿里云控制台创建的access key
      accessKeySecret: '<Your AccessKeySecret>',  //通过阿里云控制台创建的access secret
      stsToken: '', //使用临时授权方式，详情请参见使用STS访问
      bucket: 'zhidx' //通过控制台创建的bucket
    }
    this.onProgress = onProgress || noop
    this.onSuccess = onSuccess || noop
    this.onError = onError || noop
  }
  upload (file) {
    this.file = file
    if (file.type.indexOf('audio') > -1) {
      // Promise.all([this.getAudioDuration(), this.send()]).then(res => {
      //   if (res[1].resultCode == 1) {
      //     res[1].result.duration = res[0]
      //     this.onSuccess(res[1],this.file)
      //   }else{
      //     this.onError(this.file);
      //   }
      // }).catch(err => {
      //   this.onError(this.file);
      //   console.log('上传错误：' + err)
      // })
      this.getAudioDuration().then(duration => {
        return this.send()
      }).then(res => {
        console.log(res);
        if (res.resultCode == 1) {
          res.result.duration = this.duration
          this.onSuccess(res, this.file)
        } else {
          this.onError(this.file);
        }
      }).catch(err => {
        this.onError(this.file);
        console.log('上传错误：' + err)
      })
    }
    // else if (file.type.indexOf('video') > -1) {
    //   Promise.all([this.getVideoDuration(), this.send()]).then(res => {
    //     // console.log(res)
    //   }).catch(err => {
    //     console.log('上传错误：' + err)
    //   })
    // }
  }
  send () {
    return new Promise((resolve) => {
      let date = new Date(),
        y = date.getFullYear(),
        m = date.getMonth() + 1,
        m_str = m > 9 ? m : '0' + m,
        ran_str = util.randomId(),
        name = `live/uploads/materials/${y}/${m_str}/${ran_str}_${this.duration}-${this.file.name}`
      _getAliYunSts().then(({ result }) => {
        //添加文件上传的参数
        this.options.accessKeyId = result.AccessKeyId
        this.options.accessKeySecret = result.AccessKeySecret
        this.options.stsToken = result.SecurityToken
        this.client = new OSS(this.options)
      }).then(() => {
        this.client.multipartUpload(name, this.file, {
          headers: { "content-type": "application/json" },
          mime: this.file.type,
          parallel: 5,
          partSize: 1 * 1024 * 1024,
          progress: (p, checkpoint) => {
            // 断点记录点。 浏览器重启后无法直接继续上传，需用户手动触发进行设置。
            let tempCheckpoint = checkpoint ? checkpoint : { file: this.file }
            this.onProgress({ ...{ progress: (~~(p * 100)) }, ...tempCheckpoint })
          },
        }).then(res => {
          // course_id: 171
          // created_at: "2019-09-06 19:44:54"
          // duration: 0
          // id: 116
          // link: "https://oss.zhidx.com/live/uploads/materials/2019/09/5d7246b552056-3.jpeg"
          // name: "3.jpeg"
          // size: "38K"
          // state: 1
          // type: "image"
          // updated_at: "2019-09-06 19:44:54"

          let resultData
          if (res.res.statusCode == 200) {
            //文件太小不分片的时候没有?参数，需兼容
            let linkIdx = res.res.requestUrls[0].indexOf('?'),
              link = decodeURI(linkIdx > -1 ? res.res.requestUrls[0].substr(0, linkIdx) : res.res.requestUrls[0])
            resultData = {
              resultCode: 1,
              result: {
                link,
                size: this.file.size,
                name: this.file.name
              }
            }
          } else {
            resultData = {
              errorMsg: '上传失败',
              resultCode: 0
            }
          }
          resolve(resultData)
        }).catch(err => {
          console.log(err);
          this.onError(this.file)
        })
      })
    })
  }
  getAudioDuration () {
    return new Promise((resolve) => {
      let that = this
      let url = URL.createObjectURL(this.file);
      let audio = new Audio()
      audio.src = url
      audio.load()
      // console.log(11112);
      audio.oncanplaythrough = function () {
        that.duration = Math.round(this.duration)
        // console.log(this);
        resolve(that.duration)
        // audio = null
      }
    })

  }
  getVideoDuration () {
    return new Promise((resolve) => {
      let url = URL.createObjectURL(this.file);
      let video = new Video()
      video.src = url
      video.load()
      video.oncanplaythrough = function () {
        that.duration = Math.round(this.duration)
        video = null
        resolve(that.duration)
      }
    })

  }
}